import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import LevelDisplay from '../connect/LevelDisplay';
import ToggleCaseButton from '../connect/ToggleCaseButton';
import { getLevelDataProp } from '../Data';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import Game from './Game';

export default class SelectScreen extends Phaser.Scene {
  static get KEY() { return 'SelectScreen'; }

  create() {
    this.cameras.main.setBackgroundColor(0x253453);
    this.selectedLevels = [];
    this.levelSound = null;

    this.title = ABCyaPhaser.Images.addImage(this.scale.width / 2, 25, "Title", this).setOrigin(0.5, 0);

    if (gameData.isAlphabet) {
      gameData.isUppercase = true;
      this.caseSelector = new ToggleCaseButton(this);
      this.add.existing(this.caseSelector);
      this.caseSelector.x = this.scale.width / 2;
      this.caseSelector.y = 420;

      this.levelGroup = this.add.container();

      let levelname = "alphabet";
      let startNum = getLevelDataProp(this, levelname, "minNum");
      let endNum = getLevelDataProp(this, levelname, "maxNum");
      let item = new LevelDisplay(this, 1, levelname, startNum, endNum, 600, 50, 0, 5);
      let c1 = getLevelDataProp(this, levelname, "introBgColor");
      this.cameras.main.setBackgroundColor(Phaser.Display.Color.HexStringToColor(c1).color);
      let c2 = getLevelDataProp(this, levelname, "introDotColor");
      item.setDisplay(Phaser.Display.Color.HexStringToColor(c2).color, Phaser.Display.Color.HexStringToColor(c2).color, 0);
      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onLevelClick(item));
      item.x = 0;
      item.y = 0;
      this.levelGroup.add(item);
      item.doIntro(100, false);

      const levelDisplayWidth = item.getBounds().width;
      this.levelGroup.x = (this.scale.width / 2) - levelDisplayWidth / 2;
      this.levelGroup.y = 200;

      this.btnGo = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height - 130, "BtnIntroGo", this).setOrigin(0.5).setInteractive();
      this.btnGo.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onGoClick, this);
    }
    else {
      let levelItem = new LevelDisplay(this, "level1", 1, 10);

      this.levelGroup = this.add.container();

      let cw = levelItem.workingWidth;
      let ch = levelItem.workingHeight;
      let startX = 32;
      let startY = 32;
      let hPadding = 56;
      let vPadding = 16;

      let lastItem = null;
      this.levelSelectors = [];
      let levelCount = 10;
      let row = 0;
      let col = 0;
      let c1 = "#000000";
      let c2 = "#000000";
      let startNum = 0;
      let endNum = 0;

      let introWait = 0;
      for (let i = 0; i < levelCount; i++) {
        let levelname = "level" + (i + 1);
        startNum = getLevelDataProp(this, levelname, "minNum");
        endNum = getLevelDataProp(this, levelname, "maxNum");
        let item = new LevelDisplay(this, (i + 1), levelname, startNum, endNum);
        c1 = getLevelDataProp(this, levelname, "introBgColor");
        c2 = getLevelDataProp(this, levelname, "introDotColor");
        item.setDisplay(Phaser.Display.Color.HexStringToColor(c1).color, Phaser.Display.Color.HexStringToColor(c2).color, 4);
        if (gameData.levelInfo.completedLevels.indexOf((i + 1)) >= 0) {
          item.select();
        }
        let perfect = false;
        if (gameData.levelInfo.perfectLevels.indexOf((i + 1)) >= 0) {
          perfect = true;
        }
        item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onLevelClick(item));
        item.x = startX + (row * cw);
        item.y = startY + (col * ch) + (col * vPadding);
        this.levelSelectors.push(item);
        this.levelGroup.add(item);
        col++;
        if (i === 4) {
          col = 0;
          cw = levelItem.workingWidth + hPadding;
          row++;
        }
        item.doIntro(introWait, perfect);
        introWait += 180;
        lastItem = item;
      }

      this.levelGroup.x = (this.scale.width / 2) - (lastItem.dotDistance + lastItem.circleSize * 0.5 + hPadding + startX);
      this.levelGroup.y = 150;

      this.btnGo = ABCyaPhaser.Images.addImage(this.scale.width / 2, this.scale.height - 60, "BtnPlayAll", this).setOrigin(0.5).setInteractive();
      this.btnGo.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onGoClick, this);

      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._connect_the_dots_to_make_a_picture, this);
    }
  }

  onLevelClick(sender) {
    let btn = sender;
    this.selectedLevels.push(btn.levelNum);
    gameData.levelInfo.selectedLevels = this.selectedLevels.slice(0);
    gameData.levelInfo.totalLevels = this.selectedLevels.length;
    gameData.levelInfo.maxLevel = this.selectedLevels.length;
    gameData.levelInfo.currentLevelIndex = 0;
    gameData.levelInfo.currentLevel = this.selectedLevels[gameData.levelInfo.currentLevelIndex];

    this.tweens.killAll();
    this.sound.stopAll();
    this.scene.start(Game.KEY);
  }

  onGoClick() {
    this.tweens.killAll();
    this.sound.stopAll();

    if (gameData.isAlphabet) {
      this.scene.start(Game.KEY);
    }
    else {
      if (this.selectedLevels.length <= 0) {
        let levelCount = 10;
        for (let i = 0; i < levelCount; i++) {
          this.selectedLevels.push(i + 1);
        }
      }
      gameData.levelInfo.selectedLevels = this.selectedLevels.slice(0);
      gameData.levelInfo.totalLevels = this.selectedLevels.length;
      gameData.levelInfo.maxLevel = this.selectedLevels.length;
      gameData.levelInfo.currentLevelIndex = 0;
      gameData.levelInfo.currentLevel = this.selectedLevels[gameData.levelInfo.currentLevelIndex];
      this.scene.start(Game.KEY);
    }
  }
}